// extracted by mini-css-extract-plugin
export default {"sectionview":"a479988ddac653e84e75","title":"c5b3b152ed7cc9cbb3ef","fields":"fdf80cc54eb531758317","container":"c1300c862c9bbce6338b","image":"c4c59e91f8fe4e551b87"};